import { fetchWithState, getFetchedJSON } from '~/misc/fetch';
import { ActionError } from '~/misc/dispatch';

const getRatioListAPI = (getState, saveData) =>
  fetchWithState(getState, {
    method: 'POST',
    url: `/tl/v2/shipment/state/count/common`,
    body: saveData,
  })
    .then(getFetchedJSON)
    .catch(error => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const getRatioListAction = getData => (_, getSate) => getRatioListAPI(getSate, getData);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/apis/capaCityPatio.js